import { render, staticRenderFns } from "./ModalUsersOrders.vue?vue&type=template&id=3f0608ee&scoped=true&"
import script from "./ModalUsersOrders.vue?vue&type=script&lang=js&"
export * from "./ModalUsersOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalUsersOrders.vue?vue&type=style&index=0&id=3f0608ee&scoped=true&lang=css&"
import style1 from "./ModalUsersOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0608ee",
  null
  
)

export default component.exports